export default {"src":"/_next/static/media/dailyhunt.2f8092b7.svg","height":105,"width":241,"blurWidth":0,"blurHeight":0};